import { createFileRoute } from "@tanstack/react-router";
import { PharmaciesPage } from "@/features/admin/pharmacies-page";
import { ensureAdminAccess } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/apteki")({
	beforeLoad: async () => {
		await ensureAdminAccess();
	},
	component: PharmaciesPage,
});
